export default {"src":"/_next/static/media/niet-roken.3e5a0c6d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};